// extracted by mini-css-extract-plugin
var _1 = "MoreItem-modulemoreItem__tyKoI MultiValuedListMoreItem-moduleMultiValuedListMoreItem__SSTEE";
export { _1 as "moreItem" }
